import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import StartHere from "./pages/StartHere";
import Assessment from "./pages/Assessment";
import SupportOptions from "./pages/SupportOptions";
import HowIWork from "./pages/HowIWork";
import SleepHelp from "./pages/SleepHelp";
import Article from "./pages/Article";
import ParentStories from "./pages/ParentStories";
import About from "./pages/About";
import BookCall from "./pages/BookCall";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import PrivacyTerms from "./pages/PrivacyTerms";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
}

function Shell() {
  useLenis();
  return (
    <>
      <ScrollManager />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/start-here" element={<StartHere />} />
          <Route path="/sleep-assessment" element={<Assessment />} />
          <Route path="/support-options" element={<SupportOptions />} />
          <Route path="/how-i-work" element={<HowIWork />} />
          <Route path="/sleep-help" element={<SleepHelp />} />
          <Route path="/sleep-help/:slug" element={<Article />} />
          <Route path="/parent-stories" element={<ParentStories />} />
          <Route path="/about" element={<About />} />
          <Route path="/book-a-call" element={<BookCall />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/privacy-terms" element={<PrivacyTerms />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Shell />
      <Toaster position="bottom-center" richColors />
    </BrowserRouter>
  );
}

export default App;
